import { BrowserRouter as Router } from "react-router-dom";
import Main from "./Components/Utils/Main";

function App() {
  return (
    <Router>
      <Main />
    </Router>
  );
}

export default App;
